// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__Y3Yrk","tab":"ProcedureTabs_tab__2brrU"};